import ajax from '@/lib/ajax';
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { AppModule } from '@/store/modules/app';
import axios from 'axios';
import NewWorkersReportRequest from '@/models/Reports/NewWorkersReportRequest';
import PayrollReportRequest from '@/models/Reports/PayrollReportRequest';
import TimesheetReportRequest from '@/models/Reports/TimesheetReportRequest';
import DeductionsReportRequest from '@/models/Reports/DeductionsReportRequest';
import ShiftStatisticsByPositionDto from '@/models/Reports/ShiftStatisticsByPositionDto';
import JobPlacementsReportRequest from '@/models/Reports/JobPlacementsReportRequest';
import NotesReportRequest from '@/models/Reports/NotesReportRequest';


export interface IReportsState {
  loading: boolean;
  loadingDialog: boolean;
  shiftStatisticsByPosition: ShiftStatisticsByPositionDto[];
}

@Module({ dynamic: true, store, name: 'Reports', namespaced: true})
class Reports extends VuexModule implements IReportsState {
  
  public loading = false;
  public loadingDialog = false;
  public shiftStatisticsByPosition: ShiftStatisticsByPositionDto[] = [];

  @Action
  public async getShiftStatisticsByPosition() {
    this.setLoading(true);
    await ajax.get(`/api/v1/agency/reports/bookings/shift-statistics-by-position`)
      .then(response => {
        if (response.data === null) {
          response.data = [];
        }
        this.context.commit("setShiftStatisticsByPosition", response.data);
        this.setLoading(false);
      })
      .catch(error => {
        AppModule.handleApiError(error);
        this.setLoading(false);
      });
    
  }

  @Action
  async getSageNewWorkers(request: NewWorkersReportRequest) {
    this.setLoading(true);
    await ajax.post(`/api/v1/agency/reports/new-workers/sage`, request, {
      responseType: 'blob',
      timeout: 30000,
    })
    .then(response => {
        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'NewWorkers.csv');
        document.body.appendChild(fileLink);
        fileLink.click();
      this.setLoading(false);

    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoading(false);
    });
  }

  @Action
  async getSagePayroll(request: PayrollReportRequest) {
    this.setLoading(true);
    await ajax.post(`/api/v1/agency/reports/payroll/sage`, request, {
      responseType: 'blob',
      timeout: 30000,
    })
    .then(response => {
        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Payroll.csv');
        document.body.appendChild(fileLink);
        fileLink.click();
      this.setLoading(false);

    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoading(false);
    });
  }


  @Action
  async getSageDeductions(request: DeductionsReportRequest) {
    this.setLoading(true);
    await ajax.post(`/api/v1/agency/reports/deductions/sage`, request, {
      responseType: 'blob',
      timeout: 30000,
    })
    .then(response => {
        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Deductions.csv');
        document.body.appendChild(fileLink);
        fileLink.click();
      this.setLoading(false);

    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoading(false);
    });
  }


  @Action
  async getTimesheets(request: TimesheetReportRequest) {
    this.setLoading(true);
    await ajax.post(`/api/v1/agency/reports/timesheets`, request, {
      responseType: 'blob',
      timeout: 30000,
    })
    .then(response => {
        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Timesheets.csv');
        document.body.appendChild(fileLink);
        fileLink.click();
      this.setLoading(false);

    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoading(false);
    });
  }

  @Action
  async getJobPlacements(request: JobPlacementsReportRequest) {
    this.setLoading(true);
    await ajax.post(`/api/v1/agency/reports/placements`, request, {
      responseType: 'blob',
      timeout: 30000,
    })
    .then(response => {
        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Placements.csv');
        document.body.appendChild(fileLink);
        fileLink.click();
      this.setLoading(false);

    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoading(false);
    });
  }

  @Action
  async getNotes(request: NotesReportRequest) {
    this.setLoading(true);
    await ajax.post(`/api/v1/agency/reports/notes`, request, {
      responseType: 'blob',
      timeout: 30000,
    })
    .then(response => {
        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Notes.csv');
        document.body.appendChild(fileLink);
        fileLink.click();
      this.setLoading(false);

    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoading(false);
    });
  }

  @Action
  cleanState() {
    this.context.commit("resetState");
  }

  @Mutation
  resetState() {
    this.loading = false;
    this.loadingDialog = false;
  }

  @Mutation
  private async setLoading(isLoading: boolean) {
      this.loading = isLoading;
  }

  @Mutation
  private async setLoadingDialog(isLoadingDialog: boolean) {
      this.loadingDialog = isLoadingDialog;
  }

  @Mutation
  private async setShiftStatisticsByPosition(response: ShiftStatisticsByPositionDto[]) {
      this.shiftStatisticsByPosition = response;
  }
}

export const ReportsModule = getModule(Reports)
